export const UserAction = {
	LOGIN_SUCCESS: "LOGIN_SUCCESS",
	LOGOUT: "LOGOUT",
	PHONE_UPDATE: "PHONE_UPDATE",
	LOAD_USER_PROFILE: "LOAD_USER_PROFILE",

	PROFILE_PIC_UPDATE: "PROFILE_PIC_UPDATE",
	BANNER_UPDATE: "BANNER_UPDATE"
};

export const MessageAction = {
	MESSAGE : "MESSAGE",
	MESSAGE_WITH_ACTION: "MESSAGE_WITH_ACTION",
	CLEAR_MESSAGE: "CLEAR_MESSAGE"
};

export const DesignerAction = {
	LOAD_BALANCE: "LOAD_BALANCE",

	LOAD_CACHABLE_SALES_TARGET: "LOAD_CACHABLE_SALES_TARGET",

	LOAD_ALL_PENDING_ORDERS: "LOAD_ALL_PENDING_ORDERS",

	LOAD_POPULAR_STORES: "LOAD_POPULAR_STORES",

	LOAD_ALL_STORES: "LOAD_ALL_STORES",

	LOAD_POPULAR_ARTISTS: "LOAD_POPULAR_ARTISTS",

	LOAD_ACTIVE_ARTISTS: "LOAD_ACTIVE_ARTISTS",

	LOAD_ALL_ARTISTS: "LOAD_ALL_ARTISTS",
};


export const ProductAction = {
	LOAD_FEATURED_PRODUCTS: "LOAD_FEATURED_PRODUCTS",

	LOAD_POPULAR_PRODUCTS: "LOAD_POPULAR_PRODUCTS",

	LOAD_DASHAIN_FEATURED_PRODUCTS: "LOAD_DASHAIN_FEATURED_PRODUCTS",

	LOAD_RECENT_PRODUCTS: "LOAD_RECENT_PRODUCTS",

	LOAD_RECENT_PRODUCTS_PER_TYPE: "LOAD_RECENT_PRODUCTS_PER_TYPE",

	LOAD_USER_PRODUCTS: "LOAD_USER_PRODUCTS",
	LOAD_USER_PRODUCTS_PER_TYPE: "LOAD_USER_PRODUCTS_PER_TYPE",
	LOAD_STORE_PRODUCTS: "LOAD_STORE_PRODUCTS",
	
	LOAD_SINGLE_PRODUCT: "LOAD_SINGLE_PRODUCT",

	LOAD_PRODUCT_STAT: "LOAD_PRODUCT_STAT",

	LOAD_ALL_PRODUCTS: "LOAD_ALL_PRODUCTS",

	LOAD_TAG_PRODUCTS: "LOAD_TAG_PRODUCTS",

	LOAD_TYPE_PRODUCTS: "LOAD_TYPE_PRODUCTS",

	SEARCH_PRODUCTS: "SEARCH_PRODUCTS",

	UPDATE_PRODUCT_STATE: "UPDATE_PRODUCT_STATE",

	UPLOAD_NEW_PRODUCT: "UPLOAD_NEW_PRODUCT",

	LOAD_DISCOUNTED_PRODUCTS: "LOAD_DISCOUNTED_PRODUCTS"
}

export const OrderAction = {
	PLACE_ORDER: "PLACE_ORDER",

	LOAD_DISCOUNT_COUPON: "LOAD_DISCOUNT_COUPON",

	LOAD_PRODUCT_ORDERS: "LOAD_PRODUCT_ORDERS",

	LOAD_USER_ORDERS: "LOAD_USER_ORDERS",

	LOAD_ALL_ORDERS_BY_STATE: "LOAD_ALL_ORDERS_BY_STATE",

	LOAD_DASHAIN_CAMPAIGN_ORDERS: "LOAD_DASHAIN_CAMPAIGN_ORDERS",

	LOAD_CHETAN_CAMPAGIN_ORDERS: "LOAD_CHETAN_CAMPAGIN_ORDERS",

	UPDATE_ORDER_STATE: "UPDATE_ORDER_STATE",

	LOAD_ORDER_STAT: "LOAD_ORDER_STAT",

	LOAD_SINGLE_ORDER: "LOAD_SINGLE_ORDER",

	UPDATE_SINGLE_ORDER: "UPDATE_SINGLE_ORDER",
};


export const RedeemAction = {
	LOAD_REDEEM_HISTORY: "LOAD_REDEEM_HISTORY",
	REDEEMED: "REDEEMED",
};


export const StockAction = {
	LOAD_STOCK_OWNERS: "LOAD_STOCK_OWNERS",
	LOAD_SINGLE_STOCK_OWNER: "LOAD_SINGLE_STOCK_OWNER",

	LOAD_OWNER_STOCKS: "LOAD_OWNER_STOCKS",
	CLEAR_OWNER_STOCKS: "CLEAR_OWNER_STOCKS",

	LOAD_STOCK_HISTORY: "LOAD_STOCK_HISTORY"
};


// WEBPACK FOOTER //
// ./src/AppAction.js